import apiClient from '@/api/index'
import router from '@/router';

export const feedbackEditModule = {
    namespaced: true,

    state:() => ({
        reportData: {},
        reportLoading: true,
        excelData: {},
    }),

    mutations: {
        setReportData(state, data) {
            state.reportData = data
        },

        setExcelData(state, data) {
            state.excelData = data
        }
    },

    actions: {
        async getReportData({ commit, state }) {
            state.reportLoading = true
            try {
                const response = await apiClient.get(`/sale-plans/${router.currentRoute.value.query['shop']}?month=${router.currentRoute.value.query['month']}&type=DeliveryPickUp`, {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                console.log(response.data);
                commit('setReportData', response.data.results)
                commit('setExcelData', response.data.results)
            } catch(err) { // Если есть ошибка
                alert(err)
            }

            state.reportLoading = false
        },

        async changeData({}, data) {
            let summary = null
            console.log(data);

            switch(data.type) {
                case 'reviews_resolved_count':
                    summary = {
                        reviews_resolved_count: data.value 
                    }
                    break;
                case 'reviews_yandex_count':
                    summary = {
                        reviews_yandex_count: data.value 
                    }
                    break;    
                case 'reviews_yandex_negative_count':
                    summary = {
                        reviews_yandex_negative_count: data.value 
                    }
                    break;
            }

            try {
                const response = await apiClient.patch(`/sale-plans/${router.currentRoute.value.query['shop']}/${data.id}`,
                summary,
                {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
            } catch(err) { // Если есть ошибка
                alert(err)
            }
        },
    }
}